export default "__VITE_ASSET__35702370__"